module.exports = __webpack_public_path__ + "static/media/logoLoginOption.6db98ad7.png";